import { render, staticRenderFns } from "./ClaimDetail.vue?vue&type=template&id=79dc166e&scoped=true"
import script from "./ClaimDetail.vue?vue&type=script&lang=js"
export * from "./ClaimDetail.vue?vue&type=script&lang=js"
import style0 from "./ClaimDetail.vue?vue&type=style&index=0&id=79dc166e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc166e",
  null
  
)

export default component.exports